export default __webpack_public_path__ + "static/media/cheese.d8ea9f0e.png";